module.exports = __webpack_public_path__ + "img/ios.cffb1c85.jpg";